module.exports = __webpack_public_path__ + "img/icon-red-cross.e78a8bb0.jpg";